import { ForwardedRef, forwardRef } from 'react'

import type { IApplication } from '@/apis/apps/interfaces'

import { PRODUCT_PAGE_TABS } from '@/constants'
import { WIDGET_CARD_DICTIONARY } from '@/constants/products'
import useHydrationContext from '@/hooks/useHydrationContext'
import { Developer } from '@/interfaces/developers'
import { getUniqueListByKey } from '@/utils/func'

import Section from '../Section'
import TutorialBanner from './TutorialBanner'
import VerifiedCopy from './VerifiedCopy'
import CardList from './WidgetCards/CardList'

interface Props {
  product: IApplication
  developer?: Developer
  isVerifiedApp: boolean
  innerRef: ForwardedRef<HTMLElement>
}

const Support = ({ product, developer, isVerifiedApp, innerRef }: Props) => {
  const {
    product: designation,
    id: appId,
    name,
    slug,
    tutorialUrl,
    widgets,
    ownerId,
  } = product
  const hydrated = useHydrationContext()

  const { contactEmail, company = '' } = developer || {}
  const uniqueWidgets = getUniqueListByKey(widgets || [], 'placement').filter(
    ({ placement }) => Object.keys(WIDGET_CARD_DICTIONARY).includes(placement)
  )

  return (
    <Section
      id={PRODUCT_PAGE_TABS.SUPPORT}
      title="Tutorial & Support"
      ref={innerRef}
    >
      <TutorialBanner
        name={name}
        company={company}
        contactEmail={contactEmail}
        designation={designation}
        tutorialUrl={tutorialUrl}
        ownerId={ownerId}
      />

      {hydrated && (
        <CardList
          widgets={uniqueWidgets}
          appId={appId}
          slug={slug}
          designation={designation}
        />
      )}

      {hydrated && isVerifiedApp && <VerifiedCopy />}
    </Section>
  )
}

export default forwardRef((props: Props, ref: ForwardedRef<HTMLElement>) => (
  <Support {...props} innerRef={ref} />
))
